import * as React from 'react';
export const revolutSvg = React.forwardRef(function revolutSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#191C1F',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M13.465 10.936H10V26h3.465V10.936Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#fff',
      d: 'M24.332 11.797C24.332 8.601 21.911 6 18.935 6H10v3.217h8.51c1.347 0 2.462 1.138 2.487 2.536.012.7-.232 1.36-.688 1.86-.456.5-1.066.776-1.717.776h-3.315c-.117 0-.213.102-.213.229v2.86a.24.24 0 0 0 .04.133L20.73 26h4.117l-5.638-8.412c2.84-.153 5.124-2.717 5.124-5.79Z',
    }),
  );
});
revolutSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var revolut = {
  category: 'brand',
  colorable: false,
  name: 'revolut',
  svg: revolutSvg,
};
